import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { SharedPipesModule } from 'src/app/shared/pipes/shared-pipes.module';
import { SharedComponentsModule } from 'src/app/shared/components/shared-components.module';
import { SharedDirectivesModule } from 'src/app/shared/directives/shared-directives.module';

import { DocsByUserComponent } from './docsbyuser/docs-by-user.component';
import { DocsPendingComponent } from './docspending/docs-pending.component';
import { DocsByDayComponent } from './docsbyday/docs-by-day.component';
import { DocsGlobalComponent } from './docsglobal/docs-global.component';
import { DocsPendingByUserComponent } from './docspendingbyuser/docs-pending-by-user.component';
import { DocsByNifComponent } from './docsbynif/docs-by-nif.component';
import { NifBySecundaryComponent } from './nifbysecundary/nif-by-secundary.component';
import { DocsUpdatedByDayComponent } from './docsupdatedbyday/docs-updated-by-day.component';
import { TrazadoEstadoDocsComponent } from './trazadoEstadoDocumentos/trazadoEstadoDocs.component';
import { ProcesadasRobotComponent } from './procesadasRobot/procesadasRobot.component';
import { ListadoPendientesPlantillasComponent } from './listado-pendientes-plantillas/listado-pendientes-plantillas.component';
import { FalloProcAutoComponent } from './fallo-proc-auto/fallo-proc-auto.component';
import { ListadoDatosDocsSubidosPrincComponent } from './listado-datos-docs-subidos-princ/listado-datos-docs-subidos-princ.component';
import { DocsSecunTerceroComponent } from './docsSecunTerceros/docs-secun-tercero.component';
import { DocsByUserSUPComponent } from "./docsbyuserSUP/docs-by-userSUP.component";
import { DocsMultifacturaComponent } from './docsMultifactura/docs-multifactura.component';


@NgModule({
  declarations: [
    DocsByUserComponent,
    DocsMultifacturaComponent,
    DocsByUserSUPComponent,
    DocsPendingComponent,
    DocsByDayComponent,
    DocsGlobalComponent,
    DocsPendingByUserComponent,
    DocsByNifComponent,
    NifBySecundaryComponent,
    DocsUpdatedByDayComponent,
    TrazadoEstadoDocsComponent,
    ProcesadasRobotComponent,
    ListadoPendientesPlantillasComponent,
    FalloProcAutoComponent,
    ListadoDatosDocsSubidosPrincComponent,
    DocsSecunTerceroComponent
  ],
  exports: [
    DocsByUserComponent,
    DocsByUserSUPComponent,
    DocsPendingComponent,
    DocsByDayComponent,
    DocsMultifacturaComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxChartsModule,
    SharedPipesModule,
    SharedComponentsModule,
    SharedDirectivesModule
  ]
})
export class StatsModule { }
